import React, { useState, useEffect } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { api } from '../../services/api';
import ReportDateSelector, { DateRangeOption } from './ReportDateSelector';

const EngagementStickinessChart: React.FC = () => {
  const [range, setRange] = useState<DateRangeOption>('30d');
  const [stickinessData, setStickinessData] = useState<any[]>([]);

  useEffect(() => {
    let isMounted = true;
    const fetchStickiness = async () => {
      try {
        const res = await api.analytics.getStickiness(range);
        if (isMounted && res?.trend) {
          setStickinessData(res.trend);
        }
      } catch (err) {
        console.error('Failed to load stickiness trend:', err);
      }
    };
    fetchStickiness();
    return () => { isMounted = false; };
  }, [range]);

  return (
    <div id="engagement-stickiness-chart" className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm">
      <div className="flex justify-between items-start mb-6">
        <div>
          <h2 className="text-xl font-black text-slate-900 mb-1">DAU / MAU Stickiness</h2>
          <p className="text-sm text-slate-500">Live active user ratio and product engagement.</p>
        </div>
        <ReportDateSelector value={range} onChange={setRange} />
      </div>
      <div className="h-[280px]">
        {stickinessData.length === 0 ? (
          <div className="h-full flex items-center justify-center text-slate-400 text-sm">Loading stickiness metrics...</div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={stickinessData}>
              <defs>
                <linearGradient id="colorStickiness" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#10b981" stopOpacity={0.25}/>
                  <stop offset="95%" stopColor="#10b981" stopOpacity={0}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
              <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{fontSize: 12, fill: '#64748b'}} />
              <YAxis axisLine={false} tickLine={false} tick={{fontSize: 11, fill: '#64748b'}} tickFormatter={(v) => `${v}%`} />
              <Tooltip 
                contentStyle={{ borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.05)' }}
                formatter={(v: number) => [`${v}%`, 'Stickiness']}
              />
              <Area 
                type="monotone" 
                dataKey="stickiness" 
                stroke="#10b981" 
                strokeWidth={3} 
                fillOpacity={1} 
                fill="url(#colorStickiness)" 
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default EngagementStickinessChart;
